module.exports = __webpack_public_path__ + "img/visa.d39ca987.svg";